import { render, staticRenderFns } from "./PointPresenter.vue?vue&type=template&id=b465b318&scoped=true&"
import script from "./PointPresenter.vue?vue&type=script&lang=ts&"
export * from "./PointPresenter.vue?vue&type=script&lang=ts&"
import style0 from "./PointPresenter.vue?vue&type=style&index=0&id=b465b318&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b465b318",
  null
  
)

export default component.exports